import Vue from 'vue'

function createParticle(x, y, color) {
  const particle = document.createElement('div')
  particle.style.position = 'fixed'
  particle.style.left = `${x}px`
  particle.style.top = `${y}px`
  particle.style.width = '5px'
  particle.style.height = '5px'
  particle.style.backgroundColor = color
  particle.style.borderRadius = '50%'
  particle.style.pointerEvents = 'none'
  particle.style.zIndex = '9999'
  document.body.appendChild(particle)

  const animation = particle.animate([
    { transform: 'translate(0, 0)', opacity: 1 },
    { transform: `translate(${Math.random() * 100 - 50}px, ${Math.random() * 100 - 50}px)`, opacity: 0 }
  ], {
    duration: 1000,
    easing: 'cubic-bezier(0, .9, .57, 1)'
  })

  animation.onfinish = () => particle.remove()
}

function generateRandomColor() {
  return `hsl(${Math.random() * 360}, 100%, 50%)`
}

Vue.directive('rainbow-sparkle', {
  bind(el) {
    el.addEventListener('click', (e) => {
      const rect = el.getBoundingClientRect()
      const x = e.clientX - rect.left
      const y = e.clientY - rect.top

      for (let i = 0; i < 30; i++) {
        setTimeout(() => {
          createParticle(e.clientX, e.clientY, generateRandomColor())
        }, i * 20)
      }
    })
  }
})